const IN_APP_BROWSERS_REGEXP = /(FBAN\/|FBAV\/|FB_IAB\/|FBSV\/|Instagram\s[0-9]+\.[0-9]+\.[0-9]+)/i;

/**
 * Detects if the user agent belongs to an in-app browser (e.g., Facebook, Instagram).
 * @param agent
 */
export function isInAppBrowser(agent: string) {
  return IN_APP_BROWSERS_REGEXP.test(agent);
}